import { GiftCardShippingFormModel } from './GiftCardShippingFormModel';
import type { IClassicShippingForm } from './IClassicShippingForm';
import type { IGiftCardShippingForm } from './IGiftCardShippingForm';
import { ShippingFormModel as ClassicShippingFormModel } from './ShippingFormModel';

/* Note: the definitions below are not aliases, but rather union types 
in case additional shipping form types are added in the future. */

/** Represents a shipping form for a digital product like a gift card. */
export type IDigitalShippingForm = IGiftCardShippingForm;
/** Represents a shipping form model for a digital product like a gift card. */
export type DigitalShippingFormModel = GiftCardShippingFormModel;

/** Represents a shipping form for a physical product. */
export type IPhysicalShippingForm = IClassicShippingForm;
/** Represents a shipping form model for a physical product. */
export type PhysicalShippingFormModel = ClassicShippingFormModel;

/** Represents a shipping form for both physical and digital products. */
export type IShippingForm = IPhysicalShippingForm | IDigitalShippingForm;
/** Represents a shipping form model for both physical and digital products. */
export type ShippingFormModel =
  | PhysicalShippingFormModel
  | DigitalShippingFormModel;

/**
 * Checks if the shipping form is a physical shipping form.
 * @param shippingForm - The shipping form to check.
 * @returns `true` if the shipping form is a physical shipping form, `false` otherwise.
 */
export const isPhysicalShippingForm = (
  shippingForm: ShippingFormModel
): shippingForm is PhysicalShippingFormModel => {
  return shippingForm instanceof ClassicShippingFormModel;
};

/**
 * Checks if the shipping form is a digital shipping form.
 * @param shippingForm - The shipping form to check.
 * @returns `true` if the shipping form is a digital shipping form, `false` otherwise.
 */
export const isDigitalShippingForm = (
  shippingForm: ShippingFormModel
): shippingForm is DigitalShippingFormModel => {
  return shippingForm instanceof GiftCardShippingFormModel;
};
